module.exports = __webpack_public_path__ + "forgot.password.cshtml";